import { Pipe, PipeTransform } from '@angular/core';
import {map, Observable} from "rxjs";
import {Tag} from "../models/tag";
import {TagService} from "../services/tag.service";

@Pipe({
  name: 'tagIconPreview',
  standalone: true
})
export class TagIconPreviewPipe implements PipeTransform {
  constructor(private tagService: TagService) {
  }

  transform(value: Tag): Observable<string> {
    return this.tagService
      .icon(value)
      .pipe(
        map(blob => URL.createObjectURL(blob))
      );
  }

}

